import { ContactCard } from './ContactCard';
import { FAQItem } from './FAQItem';

type FAQ = {
  id: string;
  question: string;
  answer: string;
};

interface FAQSectionProps {
  faqs: FAQ[];
}

export function FAQSection({ faqs }: FAQSectionProps) {
  return (
    <section id="faqs" className="max-w-6xl mx-auto my-16 px-4 sm:px-6">
      <div className="mb-10 text-center">
        <span className="inline-block rounded-full bg-primary/10 px-4 py-1 text-sm font-semibold uppercase tracking-wide text-primary">
          FAQ
        </span>
        <h2 className="mt-4 text-3xl font-bold text-gray-900 md:text-4xl">
          Frequently Asked Questions
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-base text-gray-500">
          Everything you need to know about our products, shipping, and
          support.
        </p>
      </div>

      <div className="flex flex-col items-start gap-8 lg:flex-row lg:gap-12">
        <div className="w-full lg:flex-[2]">
          {faqs.map((faq, index) => (
            <FAQItem
              key={faq.id}
              question={faq.question}
              answer={faq.answer}
              initialOpen={index === 0}
            />
          ))}
        </div>
        <div className="w-full lg:w-auto lg:flex-1">
          <ContactCard />
        </div>
      </div>
    </section>
  );
}
